/*
 * @Author: Teemo Ding
 * @Date: 2021-11-16 09:38:06
 * @LastEditTime: 2023-02-06 16:35:31
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/SendTemplate/index.tsx
 */
import {
  Button,
  CheckboxGroup,
  Label,
  ModalFooter,
  Select,
} from '@/src/components/Antd';
import { getAllTemplates } from '@/src/request/common';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const SendTemplate = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const checkboxLabel = (buyerEmail, buyerPhoneNo) => [
    {
      value: 'Email',
      label: `${getI18n('general.email')} ${
        buyerEmail ? `(${buyerEmail})` : ''
      }`,
    },
    {
      value: 'Mobile',
      label: `${getI18n('general.customer.mobileNumber')} ${
        buyerPhoneNo ? `(${buyerPhoneNo})` : ''
      }`,
    },
  ];
  const {
    onModalCancel,
    buyerEmail,
    buyerPhoneNo,
    header,
    okText,
    showBack,
    onBack,
    onConfirm,
    salesChannelUuid,
    category,
  } = props;
  const [form] = Form.useForm();

  const { data: { emailTemplates = [], smsTemplates = [] } = {} } = useRequest(
    () => getAllTemplates(category, salesChannelUuid),
  );

  const templatesOptions = (templates) =>
    templates.map((item) => ({
      value: item.uuid,
      valueText: `${item.name}${item.communicationGatewayName}`,
      label: (
        <div className={css.templates}>
          <h3> {item.name}</h3>
          <span> {item.communicationGatewayName}</span> |{' '}
          <span> {item.communicationGatewayRemarks}</span>
        </div>
      ),
    }));

  const onFinish = (values) => {
    onConfirm(values);
  };
  return (
    <Fragment>
      <Form
        name='processRefund'
        form={form}
        onFinish={onFinish}
        className={css.processRefund}>
        {header}
        <Form.Item
          name='sendTo'
          labelCol={{ span: 24 }}
          label={
            <Label
              title={getI18n(
                `allOrders.orderDetail.refund_components_processRefund_sendto`,
              )}
            />
          }
          valuePropName='checked'>
          <CheckboxGroup
            className={css.sendToCheckbox}
            checks={checkboxLabel(buyerEmail, buyerPhoneNo)}
          />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) =>
            prevValues.sendTo !== curValues.sendTo
          }>
          {({ getFieldValue }: any) => (
            <Fragment>
              {(getFieldValue('sendTo') || []).includes('Email') && (
                <Form.Item
                  label={
                    <Label
                      title={getI18n(
                        `allOrders.orderDetail.refund_components_processRefund_emailtemplate`,
                      )}
                    />
                  }
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        `allOrders.orderDetail.refund_components_processRefund_emailrequired`,
                      ),
                    },
                  ]}
                  name='emailTemplate'>
                  <Select
                    size='large'
                    options={templatesOptions(emailTemplates)}
                    placeholder={getI18n(
                      'allOrders.createneworder.components_sendtemplate_placeholder',
                    )}
                    filterOption={(input: any, option: any) =>
                      option.valueText
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    containerClassName={css.select}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              )}
              {(getFieldValue('sendTo') || []).includes('Mobile') && (
                <Form.Item
                  label={
                    <Label
                      title={getI18n(
                        `allOrders.orderDetail.refund_components_processRefund_msgtemplate`,
                      )}
                    />
                  }
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        `allOrders.orderDetail.refund_components_processRefund_msgrequired`,
                      ),
                    },
                  ]}
                  name='messageTemplate'>
                  <Select
                    size='large'
                    options={templatesOptions(smsTemplates)}
                    filterOption={(input: any, option: any) =>
                      option.valueText
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    containerClassName={css.select}
                    showSearch
                    allowClear
                    placeholder={getI18n(
                      `allOrders.orderDetail.refund_components_processRefund_placeholder`,
                    )}
                  />
                </Form.Item>
              )}
            </Fragment>
          )}
        </Form.Item>
      </Form>
      <ModalFooter
        onOk={form.submit}
        onCancel={onModalCancel}
        okText={okText || 'Process'}
        front={
          showBack && (
            <Button onClick={onBack}>
              {getI18n(
                `allOrders.orderDetail.refund_components_processRefund_back`,
              )}
            </Button>
          )
        }
      />
    </Fragment>
  );
};

export default SendTemplate;
